<template>
  <div class="heading " v-if="is_in_search">

    <ul class="list-reset mb-2 "  ><h3 class="font-extrabold text-brand-darker mb-3">{{selected_country}}</h3>
    <li v-for="city in filtered_cities" class="text-brand-darker-light hover:text-brand-light font-bold hover:underline cursor-pointer mb-1" @click="$emit('selected_city', {city_id: city.id })" :key="city.id">{{city.name}} </li>

    </ul>
  </div>
</template>

<script>

export default {
  name: 'Country',
  props: ['country', 'search'],
  created() {
    this.country.forEach((item) => {
      if (!this.selected_country) {
        this.selected_country = item.country;
      }
      this.cities.push({ name: item.name, id: item.id });
    });
    this.cities.sort((city_a, city_b) => ((city_a.name > city_b.name) ? 1 : -1));
  },
  data() {
    return {
      cities: [],
      is_in_search: true,
      selected_country: '',
      selected_city: '',
    };
  },
  computed: {
    filtered_cities() {
      return this.cities.filter(item => ((item.name.toLowerCase()).indexOf((this.search).toLowerCase())) > -1).sort((city_a, city_b) => city_b.name - city_a.name);
    },
  },
  watch: {
    filtered_cities() {
      if (!this.filtered_cities.length) {
        this.is_in_search = false;
      } else {
        this.is_in_search = true;
      }
    },
  },

};
</script>

<style lang="less" scoped>
.heading {
  font-family: 'Montserrat', sans-serif;

}
li {
  display: block;

}
</style>
